
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhatsAppSection from './components/WhatsAppSection';
import SliderSection from './components/SliderSection';
import MobileServiceSection from './components/MobileServiceSection';
import MechanicalServiceSection from './components/MechanicalServiceSection';
import BodyworkServiceSection from './components/BodyworkServiceSection';
import CafeSection from './components/CafeSection';
import TeamSection from './components/TeamSection';
import WhyChooseSection from './components/WhyChooseSection';
import ContactSection from './components/ContactSection';

const IndexV2 = () => {

  return (
    <>
    <Header /> 
    <HeroSection />
    <ServicesSection />
    <WhatsAppSection />
    <SliderSection />
    <MobileServiceSection />
    <MechanicalServiceSection />
    <BodyworkServiceSection />
    <TeamSection />
    <CafeSection />
    <WhyChooseSection />
    <ContactSection />
    </>
  );
};

export default IndexV2;